"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.833 19.583a.75.75 0 00-.75.75c0 .37.29.667.75.667.461 0 .75-.297.75-.667a.75.75 0 00-.75-.75zm-1.75.75a1.75 1.75 0 113.5 0c0 1.011-.83 1.667-1.75 1.667s-1.75-.656-1.75-1.667zM8.667 19.583a.75.75 0 00-.75.75c0 .37.289.667.75.667.46 0 .75-.297.75-.667a.75.75 0 00-.75-.75zm-1.75.75a1.75 1.75 0 113.5 0c0 1.011-.83 1.667-1.75 1.667s-1.75-.656-1.75-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.5a.5.5 0 01.5-.5H5a.5.5 0 01.488.392l3.58 16.191h8.765a.5.5 0 110 1H8.667a.5.5 0 01-.489-.392L4.598 3H2.5a.5.5 0 01-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5a.5.5 0 01.5-.5h15a.5.5 0 01.483.63l-2.417 8.917a.5.5 0 01-.483.37H8.274a.5.5 0 010-1h10.427L20.846 9H6.5a.5.5 0 01-.5-.5z"
  }));
}

var _default = SvgSubscription;
exports["default"] = _default;